<template>
    <q-modal :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss :style="showModal ? '' : 'display: none;'">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="showModal = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ podcast.audio ? podcast.audio.title : ''  }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding q-px-none">
                <div class="row full-width">
                    <div class="col-12">
                        <q-list no-border>
                            <q-item v-for="(audio, index) in audios" :key="index" @click.native="changeTrack(index)" :class="position === index ? 'bg-light' : ''">
                                <q-item-main
                                    :label="audio.audio.title"
                                    label-lines="3"
                                    :sublabel="audio.audio.origin_playlist"
                                    sublabel-lines="3"
                                />
                                <q-item-side right>
                                    <q-item-tile stamp>{{ audio.audio.duration }} </q-item-tile>
                                </q-item-side>
                            </q-item>
                        </q-list>
                    </div>
                </div>
            </div>

             <q-toolbar class="bg-white" slot="footer">
                <vue-plyr class="full-width q-pa-md podcast" ref="plyr" >
                    <audio playsinline ref="player">
                    </audio>
                </vue-plyr>
            </q-toolbar>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            podcast: {},
            changed_time: false,
            current_time: 0,
            total_time: '',
            interval: null,
            position: 0,
            progress_audio_listen_id: '',
            time_updated: 0
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            show_modal: 'podcasts/show_modal',
            audios: 'podcasts/audios',
            status: 'podcasts/status',
            type_list: 'podcasts/type_list'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showModal: {
            get() {
                return this.show_modal
            },

            set() {
                this.$store.dispatch('podcasts/SET_MODAL', [false])
            }
        },

        getResource() {
            if (this.audios.length > 0) {
                return this.audios[this.position].audio.resource_url
            }
            else return ''
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '40vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '40vw'
        },

        player () { return this.$refs.plyr.player }
    },

    methods: {
        sendPosition() {
            if (this.current_time != 0) {
                let fd = new FormData()
                fd.append('playlist_podcast_audio', this.podcast.audio.id)
                fd.append('current_time', this.current_time)
                fd.append('total_time', this.total_time)

                if(this.progress_audio_listen_id){
                    fd.append('progress_audio_listen_id', this.progress_audio_listen_id)
                }

                let url = ''

                if(this.type_list == "user_podcast" ) {
                    url = `etraining_podcast/playlist_user/${this.podcast.podcast}/audio/set_progress/`
                }
                else {
                    url = `/etraining_podcast/podcasts/${this.podcast.podcast}/set_progress/`
                }

                this.$axios.post(url, fd, this.getHeader)
                .then(response => {
                    let podcast = {}
                    podcast = this.audios[this.position]
                    podcast.audio.current_time = response.data.current_time
                    podcast.audio.progress = response.data.progress
                    podcast.audio.status_progress = response.data.status
                    this.progress_audio_listen_id = response.data.progress_audio_listen_id

                    this.$store.dispatch('podcasts/SET_PROGRESS', [podcast])

                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        setResource() {
            if(this.audios.length > this.position) {
                this.podcast = this.audios[this.position]
                this.total_time = this.podcast.audio.total_time
                this.progress_audio_listen_status = this.podcast.audio.progress_audio_listen_status
                if(this.time_updated > 0) {
                    this.current_time = this.time_updated
                    this.time_updated = 0
                }
                else {
                    this.current_time =  this.progress_audio_listen_status == 2 ? 0 : this.podcast.audio.current_time
                }
                this.progress_audio_listen_id = this.podcast.audio.progress_audio_listen_id
                this.player.source = {
                    type: 'audio',
                    title: this.podcast.audio.title,
                    sources: [
                        {
                            src: `${this.podcast.audio.resource_url}#t=${this.current_time}`,
                            type: this.$mime.lookup(this.podcast.audio.resource_url.split('?')[0])
                        }
                    ],
                }
                this.player.play()
            }
            else {
                this.$store.dispatch('podcasts/SET_STATUS', ['stopped'])
                this.$store.dispatch('podcasts/SET_MODAL', [false])
            }

        },

        playAudio() {
            this.$store.dispatch('podcasts/SET_STATUS', ['playing'])
            if (!this.changed_time) {
                this.player.currentTime = this.podcast.audio.current_time
                this.changed_time = true
            }

            this.interval = setInterval(() => {
                this.sendPosition()
            }, 30000)
        },

        pauseAudio() {
            if(this.status != 'stopped') this.$store.dispatch('podcasts/SET_STATUS', ['paused'])
                this.sendPosition()
                clearInterval(this.interval)

        },

        endedAudio() {
            this.sendPosition()
            clearInterval(this.interval)

            if (this.position < this.audios.length) {
                this.position = this.position + 1
                this.setResource()
            }
            else this.player.stop()
        },

        changeTrack(track) {
            this.sendPosition()
            clearInterval(this.interval)

            this.position = track

            this.setResource()
        },

        audioTimeUpdated(val) {
            this.time_updated = val.detail.plyr.currentTime
            this.current_time = val.detail.plyr.currentTime
        },

        metaData(val) {
            this.total_time = val.detail.plyr.media.duration
        }
    },

    watch: {
        status: function() {
            if (this.status === 'playing') {
                clearInterval(this.interval)
                this.setResource()
            }
            else if (this.status === 'paused') {
                clearInterval(this.interval)
                this.player.pause()
            }
            else if (this.status === 'stopped') {
                clearInterval(this.interval)

                this.player.stop()

                this.podcast = {}
                this.changed_time = false
                this.current_time = 0
                this.total_time = ''
                this.interval = null
                this.position=  0
            }
        }
    },

    mounted () {
        this.player.on('timeupdate', (val) => this.audioTimeUpdated(val))
        this.player.on('loadedmetadata', (val) => this.metaData(val))
        this.player.on('play', (val) => this.playAudio())
        this.player.on('pause', (val) => this.pauseAudio())
        this.player.on('ended', (val) => this.endedAudio())
    },
}
</script>

<style>

</style>